import axios from 'axios';

const url = process.env.REACT_APP_SENSEDIA_API_URL;
const CLIENT = process.env.REACT_APP_CLIENT_ID_PASS;

export const backAxiosImageZetec = token => {
    const apiZeloZetc = axios.create({
        baseURL: url,
        headers: {
            'Content-Type': 'application/json'
        }
    });

    apiZeloZetc.interceptors.request.use(
        async config => {
            try {
                const client_id = CLIENT;

                config.headers['client_id'] = await client_id;
                config.headers['access_token'] = await token;

                return config;
            } catch (error) {
                console.log('interceptor', error);
            }
        });

    return apiZeloZetc;
};